// Generated by `npm run reeffish` (scripts/reefFish.ts): the balance the octopus's stocks open at,
// its dens a hectare (Sims 1998) and the State's commercial catch (Kramer 1986), its larvae settling as
// Wren et al.'s model sends them (./exchange.ts, from data/bcodmo-665467/). Do not edit by hand.
// tests/octopus.test.ts holds the balance to a year's step.
import type { FishJanuary, FishSupply } from '../../fish';
import { REEF_FISH_EXCHANGE } from './exchange';

/** The exchange, and the balance's larvae a kilogram of spawners sends, fishing and the rest's spawners. */
export const OCTOPUS_SUPPLY: FishSupply = {
  exchange: REEF_FISH_EXCHANGE,
  larvaePerKgDay: 26.1574,
  fishingPerYear: 0.0376688,
  restSpawnersKg: 29509.4,
  predatorOtherPreyKg: { ulua: [194489, 251015, 104721, 14995.4] },
};

/** The balance's first of January (expected values; a world opening rounds the fish): each island's fish by month of age since settling, and the larvae afloat by their days to settle from that day. */
export const OCTOPUS_JANUARY: FishJanuary = {
  islands: [
    [42712.8, 28842.3, 17379.4, 8243.34, 3211.6, 2098.44, 925.224, 635.076, 354.163, 132.18, 72.7388, 36.6973, 25.7057, 0],
    [35895.9, 16579.4, 10191.1, 4309.75, 2357.42, 1187.59, 904.003, 492.361, 209.496, 144.619, 65.2022, 46.0307, 21.6033, 0],
    [44048, 24524.4, 14057, 5582.26, 3719.47, 1790.49, 950.83, 691.374, 320.531, 201.935, 99.112, 60.7493, 26.5094, 0],
    [24786.7, 14220.1, 9641.45, 3762.99, 1742.81, 912.065, 469.145, 355.272, 211.245, 66.0269, 28.4649, 27.0381, 14.9173, 0],
  ],
  afloat: [
    [1488.29, 1918.9, 2522.76, 1130.16],
    [1478.36, 1904.5, 2503.27, 1122.45],
    [1468.54, 1890.24, 2483.98, 1114.81],
    [1458.82, 1876.14, 2464.89, 1107.25],
    [1449.2, 1862.18, 2445.99, 1099.77],
    [1439.67, 1848.36, 2427.29, 1092.37],
    [1430.25, 1834.68, 2408.78, 1085.04],
    [1420.92, 1821.15, 2390.46, 1077.79],
    [1411.69, 1807.76, 2372.34, 1070.62],
    [1402.56, 1794.51, 2354.41, 1063.52],
    [1393.53, 1781.4, 2336.66, 1056.5],
    [1384.59, 1768.43, 2319.11, 1049.55],
    [1375.74, 1755.6, 2301.74, 1042.67],
    [1366.99, 1742.9, 2284.56, 1035.87],
    [1353.39, 1723.17, 2257.85, 1025.3],
    [1344.92, 1710.87, 2241.2, 1018.71],
    [1336.53, 1698.71, 2224.73, 1012.19],
    [1328.24, 1686.67, 2208.44, 1005.74],
    [1320.03, 1674.77, 2192.32, 999.358],
    [1311.91, 1662.99, 2176.39, 993.049],
    [1303.89, 1651.34, 2160.62, 986.809],
    [1295.95, 1639.83, 2145.03, 980.638],
    [1288.1, 1628.44, 2129.62, 974.534],
    [1280.33, 1617.17, 2114.37, 968.499],
    [1272.66, 1606.03, 2099.29, 962.53],
    [1265.07, 1595.02, 2084.38, 956.628],
    [1257.56, 1584.13, 2069.64, 950.793],
    [1504.21, 1941.93, 2545.12, 1140.02],
    [1494.04, 1927.18, 2525.26, 1132.15],
    [1483.98, 1912.59, 2505.6, 1124.36],
  ],
};
